import React from 'react';
import styled, { css } from 'styled-components';
import { arrayOf, bool, node, oneOfType } from 'prop-types';

import exportWithBoundary from '../../../../helpers/exportWithBoundary';

export const GridColumnContent = styled.div``;
export const GridColumnContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  align-items: center;
  min-width: 0;
  ${({ highlight }) =>
    highlight &&
    css`
      font-weight: 600;
      background: var(--neutral-100);
    `}
  ${({ multiLine }) =>
    !multiLine &&
    css`
      ${GridColumnContent} {
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    `}
`;

function GridColumn({ children, highlight }) {
  return (
    <GridColumnContainer highlight={highlight}>
      <GridColumnContent>{children}</GridColumnContent>
    </GridColumnContainer>
  );
}

GridColumn.defaultProps = {
  children: [],
  highlight: false,
};

GridColumn.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  highlight: bool,
};

function GridColumnFallback() {
  return <GridColumnContainer />;
}

export default exportWithBoundary(GridColumn, GridColumnFallback);
